export { default as DetalleCierreMensualProduccion } from "./DetalleCierreMensualProduccion";
